<template>
  <div v-title data-title="产品快照">
    <section style="padding-bottom:50px;">
      <div class="pro-list pro-details" style="padding-bottom:1px">
        <wv-swipe :height="210" :autoplay="3000">
          <wv-swipe-item v-for="(url,$index) in this.formset.ProductImgUrl" :key="$index">
            <div class="swipe-img-div">
              <img v-lazy="url" class="lazy-img-fadein" :key="$index" />
            </div>
          </wv-swipe-item>
        </wv-swipe>
        <div class="pro-num">
          <span>产品编号：{{formset.ProductNumber}}</span>
        </div>
        <div class="title">
          <a href>{{formset.ProductName}}</a>
        </div>
        <!-- <div class="tags">
          <span v-for="(tag,$index) in comboTags" :key="$index" class="label-bg">{{tag}}</span>
        </div> -->

        <div class="price" style>
          <span>
            ￥
            <b>{{CommissionInfo.SalePrice}}</b>
            <span class="fr" v-if="formset.LoginType==4&&this.formset.IsDistribute==1"></span>

            <span style="color:#999; text-decoration:line-through;font-size:14px;">
              &nbsp;市场价：￥{{CommissionInfo.PrimePrice}}
            </span>
          </span>
        </div>
      </div>

      <div style v-if="formset.LoginType==4&&this.formset.IsDistribute==1">
        <div class="mssj" v-for="(info,$index) in formset.BusinessInfos" :key="$index">
          <div class="fl">
            <div class="adress">
              <p class="adress-info" @click="toMap(info.lng,info.lat)">{{info.Adress}}</p>
            </div>
            <div class="tel" @click="zixun(info.Phone)">{{info.Phone}}</div>
          </div>
          <div class="fr">
            <img v-if="info.Type=='住宿商家'" src="../../assets/img/icon23-1.png" />
            <img v-if="info.Type=='美食商家'" src="../../assets/img/icon23-2.png" />
            <img v-if="info.Type=='玩乐商家'" src="../../assets/img/icon23-3.png" />
          </div>
          <div style="clear:both;"></div>
        </div>
      </div>
      <div v-else>
        <div class="mssj" v-for="(info,$index) in formset.BusinessInfos" :key="$index">
          <div class="fl">
            <div class="adress">
              <p class="adress-info" @click="toMap(info.lng,info.lat)">{{info.Adress}}</p>
              <!-- <p class="adress-info">名称：{{info.Name}}</p> -->
            </div>
            <div class="tel" @click="zixun(info.Phone)">{{info.Phone}}</div>
          </div>
          <div class="fr">
            <img v-if="info.Type=='住宿商家'" src="../../assets/img/icon23-1.png" />
            <img v-if="info.Type=='美食商家'" src="../../assets/img/icon23-2.png" />
            <img v-if="info.Type=='玩乐商家'" src="../../assets/img/icon23-3.png" />
          </div>
          <div style="clear:both;"></div>
        </div>
      </div>
      <div class="block-t">套餐类型</div>
      <div style="margin-top: -1.6rem;font-size:1.3rem">
        <wv-radio v-model="comboguid" :options="ComboOptions" @change="onChange"></wv-radio>
      </div>

      <div style="height:20px"></div>
      <div
        style="height:5.0rem;line-height:5.0rem;background-color:white; font-size:1.5rem"
        :class="floattab?'tab-float':''"
      >
        <div
          style="display:block;float:left;width:25%;text-align:center;"
          @click="goto('ComboContent')"
          :class="PagePosition=='ComboContent'?'tab-activett':''"
        >套餐详情</div>
        <div
          style="display:block;float:left;width:25%;text-align:center;"
          @click="goto('ProductContent')"
          :class="PagePosition=='ProductContent'?'tab-activett':''"
        >产品详情</div>
        <div
          style="display:block;float:left;width:25%;text-align:center;"
          @click="goto('ReservationContent')"
          :class="PagePosition=='ReservationContent'?'tab-activett':''"
        >预定须知</div>
        <div
          style="display:block;float:left;width:25%;text-align:center;"
          @click="goto('ChangeContent')"
          :class="PagePosition=='ChangeContent'?'tab-activett':''"
        >退改说明</div>
      </div>

      <div style="font-size:1.6rem">
        <div id="ComboContent" style="height:30px"></div>
        <div style="background-color:#fff">
          <div class="details-con-t">
            套餐详情
            <br />
            <span>INTRODUE</span>
          </div>
          <div class="productcontent tab-item-detail" v-html="CommissionInfo.ComboContent"></div>
        </div>

        <div id="ProductContent" style="height:30px"></div>
        <div style="background-color:#fff">
          <div class="details-con-t">
            产品详情
            <br />
            <span>INTRODUE</span>
          </div>
          <div class="productcontent tab-item-detail" v-html="formset.ProductContent"></div>
        </div>

        <div id="ReservationContent" style="height:30px"></div>
        <div style="background-color:#fff">
          <div class="details-con-t">
            预定须知
            <br />
            <span>RESERVATION</span>
          </div>
          <div class="productcontent tab-item-detail" v-html="formset.ReservationContent"></div>
        </div>

        <div id="ChangeContent" style="height:30px"></div>
        <div style="background-color:#fff">
          <div class="details-con-t">
            退改说明
            <br />
            <span>INTRODUCE</span>
          </div>
          <div class="productcontent tab-item-detail" v-html="formset.ChangeContent"></div>
        </div>
        
        <div v-if="products.length>0" style="background-color:#fff;margin-top: 15px;padding:15px;">

          <div class="pro-title">
            <span>猜你喜欢</span>
          </div>
          <ul class="pros-list">
            <li
              class="flex"
              v-for=" (model,$index) in products"
              :key="$index"
              @click="ProductDetail(model.Guid)"
            >
              <div class="pro-img">
                <a href="javascript:void(0)">
                  <img :src="model.ProductFirstPic" />
                </a>
                <span
                  style="background-size:32px;padding:1px 5px 10px"
                  v-if="model.IsNew==1"
                  class="tag-new"
                >新品</span>
              </div>
              <div class="pro-desc">
                <a
                  href="javascript:void(0)"
                  class="title"
                  style="max-height:42px;"
                >{{model.ProductName}}</a>
                <p class="price">
                  <span>
                    ￥
                    <b>{{model.SatrtAmount}}</b>
                  </span>
                  <span class="gray">￥{{model.PrimePrice}}</span>
                </p>
                <p class="flex">
                  <span>已售:{{model.ProductSaleCount}}</span>
                  <span
                    v-if="LoginType==4&&model.IsDistribute==1"
                    class="btn-tag"
                  >赚￥{{model.Commission}}</span>
                  <span v-else class="btn-tag">立即预定</span>
                  <!-- <span><img src="../../assets/img/shop.png" width="25"/></span> -->
                </p>
              </div>
            </li>
          </ul>
          <div class="pro">
            <p v-if="products.length!=NewTotalCount"><span @click="InitNewProduct()" class="btn-more">&gt;&gt;换一批&lt;&lt;</span></p>
            <p v-if="products.length==NewTotalCount"><span style="background: #999;" class="btn-more">更多产品敬请期待</span></p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { Toast } from "we-vue";
import Vue from "vue";
import thumb from "../../assets/logo.png";
import sharereminder from "../../assets/img/shareno.png";
import poster from "../../assets/img/poster.png";
import advisory from "../../assets/img/advisory.png";
import shoppingcart from "../../assets/img/shoppingcart.png";
import share from "../../assets/img/share.png";
import imgloading from "@/assets/img/svg-loader/circles.svg";
import imgerror from "@/assets/img/default-img.png";
import gototop from "@/assets/img/goToTop.png";
import homelink from "@/assets/img/home_link.png";
import home from "../../assets/img/home.png";
import { Dialog } from "we-vue";
import wx from "weixin-js-sdk";

export default {
  name: "product_ssdetail",
  data: function() {
    return {
      borwser: this.GLOBAL.borwser,
      LoginType: -1, //(-1=未登录/4=家游客/5=直客)
      LoginGuid: "", //当前登录家游客用户的guid
      IsAlreadyGetRole: 0, //是否已经获取角色
      productGuid: "",
      orderGuid: "",
      posterurl: "",
      posterbase64: "",
      generateposter: "", //=1标志微信授权回调后立即生成海报
      popupVisiblelogo: false, //海报生成logo选择弹出是否显示
      sharereminder: sharereminder,
      logourl: thumb,
      shoppingcart: shoppingcart,
      advisory: advisory,
      poster: poster,
      share: share,
      gototop: gototop,
      homelink: homelink,
      home: home,
      imglazy_container: {
        //懒加载图片配置
        selector: "img",
        loading: imgloading,
        error: imgerror
      },

      formset: {},
      comboguid: "",
      comboIsState: 1,
      comboTags: [],
      BusinessInfos: [],
      Tags: ["套餐详情", "产品详情", "预订须知", "退改说明"],
      PagePosition: "ComboContent",
      floattab: false,
      SelectLogos: [
        {
          label: "壹选生活",
          value: 1
        },
        {
          label: "微信个人信息",
          value: 3
        }
      ],
      logochoose: [1, 3],
      CommissionInfo: {
        Commission: "",
        SalePrice: "",
        FXPrice: "",
        PriceType: ""
      },
      ComboOptions: [],
      markDate: [],
      chooseDay: null,
      popupVisiblediy: false,
      popupVisibleshare: false,
      showcalendar: true,
      timer_day: 0,
      timer_hour: 0,
      timer_min: 0,
      timer_sec: 0,
      downloadUrl: null,
      downloadfilename: null,
      requestcomplete: false,
      products:[],
      NewTotalCount: -1,
      PageNum: 0, //当前页码
      HasNextPage: true,
    };
  },

  created: function() {
    this.orderGuid = this.$route.query.id;
    this.InitProduct();
    this.InitNewProduct();
  },

  mounted: function() {
    this.$nextTick(function() {
      //修改事件监听
      window.addEventListener("scroll", this.handleScroll, true);
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    goto: function(pagePosition) {
      this.PagePosition = pagePosition;
      document.getElementById(pagePosition).scrollIntoView();
    },
    InitNewProduct: function(type) {
      this.PageNum += 1;
      var data = {
        ProductName: "",
        IsOrderByPriceAsc: null,
        ProductTypes: [],
        ScenicareaId: null,
        HoltelId: null,
        PageSize: 4,
        PageNum: this.PageNum,
        LoginType: -1
      };
      this.$http
        .post(this.GLOBAL.BASE_URL + "api/tbproduct/productpager", data, {
          emulateJSON: true
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            this.products = rep.Data.List;
            this.disid = rep.Data.DisGuid;
            this.HasNextPage = rep.Data.Page.HasNextPage;
            this.NewTotalCount = rep.Data.Page.Total;
            var i = 0;
            for (; i < this.products.length; i++) {
              if (this.products[i].ProductName.length > 20) {
                this.products[i].ProductName =
                  this.products[i].ProductName.substring(0, 20) + "...";
              }
            }
          } else {
            Toast.fail(rep.Message);
          }
        });
    },
    //产品详情
    ProductDetail: function(orderGuid) {
      if (this.LoginType == 4) {
        this.$router.push({
          path: "/page/productdetail",
          query: {
            id: orderGuid,
            disid: this.disid
          }
        });
      } else {
        this.$router.push({
          path: "/page/productdetail",
          query: {
            id: orderGuid
          }
        });
      }
    },
    handleScroll() {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var a = document.getElementById("ComboContent").offsetTop;
      var b = document.getElementById("ProductContent").offsetTop;
      var c = document.getElementById("ReservationContent").offsetTop;
      var d = document.getElementById("ChangeContent").offsetTop;
      if (this.scrollTop > a - 50) {
        //todo
        this.floattab = true;
        //document.getElementById("ComboContent").scrollTop(200)
        this.PagePosition = "ComboContent";
        if (this.scrollTop > b - 50) {
          this.PagePosition = "ProductContent";
        }
        if (this.scrollTop > c - 50) {
          this.PagePosition = "ReservationContent";
        }
        if (this.scrollTop > d - 50) {
          this.PagePosition = "ChangeContent";
        }
      } else {
        this.floattab = false;
        this.PagePosition = "ComboContent";
      }
    },
    ToHome: function() {
      window.location.href = this.GLOBAL.WEB_URL + "/#/app/home";
    },
    ToMyFSX: function() {
      window.location.href =
        this.GLOBAL.WEB_URL +
        "/#/page/productdetail?id=" +
        this.productGuid +
        "&disid=" +
        this.LoginGuid;
    },
    setcache: function() {
      var promise = this.$http.get(this.GLOBAL.BASE_URL + "api/getdict");
      promise.then(function(d) {
        var rep = JSON.parse(d.bodyText);
        if (rep.Success) {
          localStorage.setItem("cachedict", JSON.stringify(rep.Data));
        } else {
          Toast.fail(rep.Message);
        }
      });
    },

    onChange: function(value) {
      this.showcalendar = false;
      let _this = this;
      setTimeout(function() {
        _this.showcalendar = true;
      }, 250); //延迟执行曲线刷新日历控件
      (this.chooseDay = null),
        (this.CommissionInfo = {
          Commission: "",
          SalePrice: "",
          FXPrice: "",
          PriceType: ""
        });
      this.markDate = [];
      if (this.formset.CommissionInfo != null) {
        for (var key in this.formset.CommissionInfo) {
          if (value == key) {
            this.CommissionInfo = this.formset.CommissionInfo[key];
            break;
          }
        }
        for (var key in this.formset.ComboPriceInfo) {
          if (value == key) {
            this.markDate = this.formset.ComboPriceInfo[key];
            if (
              this.markDate != undefined &&
              this.markDate != null &&
              this.markDate.length > 0
            ) {
              for (var item in this.markDate) {
                if (this.markDate[item].chooseDay == false) {
                  this.markDate[item].chooseDay = true;
                  break;
                }
              }
              for (var item in this.markDate) {
                if (this.markDate[item].chooseDay == true) {
                  this.chooseDay = this.markDate[item];
                  break;
                }
              }
            }
            break;
          }
        }
      }
      //获取当前套餐的上下架和套餐标签
      for (var item in this.formset.ComboOptions) {
        if (this.formset.ComboOptions[item].value == value) {
          this.comboIsState = this.formset.ComboOptions[item].isState;
          this.comboTags = this.formset.ComboOptions[item].comboTags;
          this.BusinessInfos = this.formset.ComboOptions[item].BusinessInfos;
        }
      }
    },
    changeDate: function(changeday) {},
    clickDay: function(chooseday) {
      this.chooseDay = chooseday;
      for (var item in this.markDate) {
        if (this.markDate[item].chooseDay == true) {
          this.markDate[item].chooseDay = false;
          break;
        }
      }
      for (var key in this.markDate) {
        if (chooseday.guid == this.markDate[key]["guid"]) {
          this.CommissionInfo = {
            Commission: this.markDate[key].Commission,
            SalePrice: this.markDate[key].price,
            FXPrice: this.markDate[key].FXPrice,
            PriceType: 2,
            isSoldOut: this.markDate[key].isSoldOut,
            PrimePrice: this.markDate[key].PrimePrice,
            IsState: this.markDate[key].IsState
          };
        }
      }
    },
    InitProduct: function(type) {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/tbproduct/getproduct_ssdetail", {
          params: {
            orderGuid: this.orderGuid
          }
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            this.LoginType = rep.Data.LoginType;
            this.LoginGuid = rep.Data.LoginGuid;
            this.formset = rep.Data;
            if (
              this.formset.ComboOptions != null &&
              this.formset.ComboOptions.length > 0
            ) {
              this.ComboOptions = this.formset.ComboOptions;
              for (var key in this.ComboOptions) {
                if (
                  !this.ComboOptions[key].isSoldOut &&
                  this.ComboOptions[key].isState == 1
                ) {
                  this.comboguid = this.ComboOptions[key].value;
                  this.comboIsState = this.ComboOptions[key].isState;
                  this.comboTags = this.ComboOptions[key].comboTags;
                  this.BusinessInfos = this.ComboOptions[key].BusinessInfos;
                  break;
                }
              }
              if (this.comboguid == "") {
                for (var key in this.ComboOptions) {
                  this.comboguid = this.ComboOptions[key].value;
                  this.comboIsState = this.ComboOptions[key].isState;
                  this.comboTags = this.ComboOptions[key].comboTags;
                  this.BusinessInfos = this.ComboOptions[key].BusinessInfos;
                  break;
                }
              }
            }
            this.requestcomplete = true;
          } else {
            this.requestcomplete = true;
            Toast.fail(rep.Message);
          }
        });
    },
    zixun: function(number) {
      if (number) {
        location.href = "tel:" + number;
        return;
      }
      if (
        this.formset.ProductContactTel == undefined ||
        this.formset.ProductContactTel == null ||
        this.formset.ProductContactTel.length == 0
      ) {
        this.formset.ProductContactTel = "18913840769";
      }
      //location.href = "tel:" + this.formset.ProductContactTel;
      location.href = "tel:18913840769";
    },
    toMap(lng, lat) {
      if (lng && lat) {
        var url = "https://uri.amap.com/marker?position=" + lng + "," + lat;
        window.location.href = url;
      } else {
        Toast.fail("商家未设置位置信息，暂时不能导航");
      }
    }
  }
};
</script>

<style>
.tab-title {
  text-align: center;
  margin-top: 20px;
}
.float-button {
  position: fixed;
  bottom: 210px;
  right: 20px;
  z-index: 100;
  width: 46px;
  height: 46px;
  background-color: #ffffff;
  border: 1px solid #eee9e4;
  text-align: center;
  font-size: 14px;
  border-radius: 30px;
  opacity: 0.9;
}

.products-labels-list span {
  display: inline-block;
  vertical-align: middle;
  margin: 0.075rem 0.5rem 0.75rem 0;
  padding: 0.1rem 0.4rem;
  -moz-border-radius: 0.15rem;
  border-radius: 0.15rem;
  color: white;
  font-size: 0.75rem;
}

.fenxiao-price {
  font-size: 0.875rem;
  margin-left: 1rem;
}

.fenxiao-button {
  font-size: 1rem;
  float: right;
}

.generateandshow {
  background: url(../../assets/img/25.png) no-repeat 5px center;
  background-size: 100% 100%;
  height: 70px;
  width: 100%;
}

.commission {
  font-size: 1.5rem;
  color: #fff;
  display: inline-block;
  vertical-align: middle;
  line-height: 70px;
  margin-left: 10%;
  width: 95px;
}
.generate {
  width: 22%;
  text-align: center;
  padding: 35px 0px;
  background: url("../../assets/img/23.png") center no-repeat;
  background-size: 100% auto;
  display: inline-block;
}
.sharebutton {
  width: 22%;
  text-align: center;
  padding: 35px 0px;
  margin-left: 2%;
  margin-right: 12%;
  background: url("../../assets/img/24.png") center no-repeat;
  background-size: 100% auto;
  display: inline-block;
}
.fenxiao-switch {
  position: fixed;
  bottom: 53px;
  font-size: 0.875rem;
  text-align: center;
  width: 100%;
  background: #fff;
  opacity: 0.8;
  line-height: 40px;
  color: #ff9800;
}
.float-home {
  position: fixed;
  bottom: 160px;
  right: 20px;
  z-index: 100;
  width: 46px;
  height: 46px;
  background-color: #ffffff;
  border: 1px solid #eee9e4;
  text-align: center;
  font-size: 14px;
  border-radius: 30px;
  opacity: 0.9;
}
.tab-activett {
  height: 5rem;
  line-height: 5rem;
  border-bottom: 2px solid #ff7135;
  font-weight: bolder;
  color: #ff7135;
}
.tab-float {
  position: fixed;
  top: 0px;
  display: flex;
  width: 100%;
}

.tab-item-detail {
  padding-left: 15px;
  padding-right: 15px;
}
span .weui-cell__ft {
  width: 82%;
}
.productcontent tab-item-detail {
  font-size: 1.3rem;
}
.productcontent video {
  width:100%;
  height:100%;
}
.countdown-warp {
  text-align: center;
  background-color: #ff7135;
  height: 2.76rem;
  line-height: 2.76rem;
  font-size: 14px;
  color: #444;
}

.countdown-warp span {
  color: #ff5251;
  background-color: #fff;
  padding: 0.3rem;
  text-align: center;
}
</style>





// WEBPACK FOOTER //
// src/components/combo/product_ssdetail.vue